<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="700">
      <v-form ref="PreferredLocationFormRef" @submit.prevent>
        <v-card class="form-card">
          <div class="dialog-header">
            <div>
              <div class="dialog-header-title">
                {{ action }} Practicum Schedule
              </div>
              <div class="dialog-header-sub">
                Fill in the activity details below
              </div>
            </div>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </div>

          <v-card-text class="form-body">
            <v-container class="pa-0">
              <v-row dense>
                <v-col cols="12">
                  <div class="field-label">
                    <v-icon size="14" class="mr-1">mdi-format-title</v-icon>
                    Title
                  </div>
                  <v-text-field
                    v-model="title"
                    placeholder="e.g. Pre-deployment Orientation"
                    :rules="[formRules.required]"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    color="#16a34a"
                    class="rounded-lg"
                  />
                </v-col>

                <v-col cols="12">
                  <div class="field-label">
                    <v-icon size="14" class="mr-1">mdi-tag-outline</v-icon>
                    Type
                  </div>
                  <v-autocomplete
                    v-model="type_selected"
                    :items="type_list"
                    item-value="value"
                    :item-title="'text'"
                    placeholder="Please select type"
                    variant="outlined"
                    density="compact"
                    hide-details
                    color="#16a34a"
                    class="rounded-lg"
                  ></v-autocomplete>
                  <span
                    v-if="type_selected"
                    class="type-preview"
                    :style="{
                      color: getTypeColor(type_selected).text,
                      backgroundColor: getTypeColor(type_selected).bg,
                    }"
                  >
                    {{ typeLabel(type_selected) }}
                  </span>
                </v-col>

                <v-col cols="12" sm="6">
                  <div class="field-label">
                    <v-icon size="14" class="mr-1">mdi-calendar</v-icon>
                    Date
                  </div>
                  <v-text-field
                    :model-value="formatDate(date_sched)"
                    variant="outlined"
                    density="compact"
                    readonly
                    hide-details="auto"
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    @click="showDatePicker1 = true"
                  ></v-text-field>

                  <v-dialog v-model="showDatePicker1" max-width="290">
                    <v-date-picker
                      v-model="date_sched"
                      @update:model-value="saveDateFrom"
                      color="#16a34a"
                    ></v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="12" sm="6">
                  <div class="field-label">
                    <v-icon size="14" class="mr-1"
                      >mdi-map-marker-outline</v-icon
                    >
                    Venue
                  </div>
                  <v-text-field
                    v-model="venue"
                    placeholder="e.g. DNSC Auditorium"
                    :rules="[formRules.required]"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    color="#16a34a"
                    class="rounded-lg"
                  />
                </v-col>

                <v-col cols="12" sm="6">
                  <div class="field-label">
                    <v-icon size="14" class="mr-1">mdi-clock-outline</v-icon>
                    Time From
                  </div>
                  <v-text-field
                    :model-value="formatTime(time_from)"
                    variant="outlined"
                    density="compact"
                    readonly
                    hide-details="auto"
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    @click="showTimePicker1 = true"
                  ></v-text-field>

                  <v-dialog v-model="showTimePicker1" max-width="400">
                    <v-card max-width="400">
                      <template v-slot:text>
                        <v-time-picker
                          v-model="time_from"
                          ampm
                          ampm-in-title
                          color="#16a34a"
                        ></v-time-picker>
                      </template>

                      <template v-slot:actions>
                        <v-btn
                          class="ms-auto"
                          text="Ok"
                          @click="saveTimeAM_IN"
                        ></v-btn>
                      </template>
                    </v-card>
                  </v-dialog>
                </v-col>

                <v-col cols="12" sm="6">
                  <div class="field-label">
                    <v-icon size="14" class="mr-1">mdi-clock-outline</v-icon>
                    Time To
                  </div>
                  <v-text-field
                    :model-value="formatTime(time_to)"
                    variant="outlined"
                    density="compact"
                    readonly
                    hide-details="auto"
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    @click="showTimePicker2 = true"
                  ></v-text-field>

                  <v-dialog v-model="showTimePicker2" max-width="400">
                    <v-card max-width="400">
                      <template v-slot:text>
                        <v-time-picker
                          v-model="time_to"
                          ampm
                          ampm-in-title
                          color="#16a34a"
                        ></v-time-picker>
                      </template>

                      <template v-slot:actions>
                        <v-btn
                          class="ms-auto"
                          text="Ok"
                          @click="saveTimeAM_OUT"
                        ></v-btn>
                      </template>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="dialog-actions">
            <v-spacer></v-spacer>
            <v-btn class="cancel-btn" elevation="0" @click="closeD()">
              <v-icon size="16" class="mr-1">mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              class="save-btn"
              elevation="0"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="action == 'Add' ? save() : update()"
            >
              <v-icon size="16" class="mr-1">mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      showDatePicker1: false,
      showTimePicker1: false,
      showTimePicker2: false,

      dialog: false,
      btnLoading: false,
      title: null,
      student_batch_id: null,
      type_selected: null,
      date_sched: null,
      time_from: null,
      time_to: null,
      venue: null,
      type_list: [
        { text: "Orientation", value: "orientation" },
        { text: "Seminar", value: "seminar" },
        { text: "Meeting", value: "meeting" },
      ],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;

        if (data.id) {
          this.title = data.title;
          this.type_selected = data.type;
          this.date_sched = data.date_sched;
          this.time_from = data.time_from;
          this.time_to = data.time_to;
          this.venue = data.venue;
        } else {
          console.log("data", data);
          this.student_batch_id = data.student_batch_id;
          this.$nextTick(() => {
            this.title = null;
            this.type_selected = null;
            this.date_sched = null;
            this.time_from = null;
            this.time_to = null;
            this.venue = null;
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    getTypeColor(type) {
      const palette = {
        orientation: { text: "#1d4ed8", bg: "#dbeafe" },
        seminar: { text: "#ea580c", bg: "#ffedd5" },
        meeting: { text: "#0284c7", bg: "#e0f2fe" },
      };
      const key = (type || "").toLowerCase().replace(/\s+/g, "_");
      return palette[key] || { text: "#15803d", bg: "#dcfce7" };
    },

    typeLabel(value) {
      const match = this.type_list.find((t) => t.value === value);
      return match ? match.text : value;
    },

    saveDateFrom() {
      if (this.date_sched) {
        this.date_sched = this.formatDate3(this.date_sched);
        this.showDatePicker1 = false;
      }
    },

    saveTimeAM_IN() {
      if (this.time_from) {
        console.log(this.time_from);
        this.showTimePicker1 = false;
      }
    },

    saveTimeAM_OUT() {
      if (this.time_to) {
        this.showTimePicker2 = false;
      }
    },

    async save() {
      let formValid = await this.$refs.PreferredLocationFormRef.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          title: this.title,
          type: this.type_selected,
          date_sched: this.date_sched,
          time_from: this.time_from,
          time_to: this.time_to,
          venue: this.venue,
          student_batch_id: this.student_batch_id,
        };

        this.axiosCall(
          "/attendance/student-prac-attendances",
          "POST",
          data,
        ).then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    async update() {
      let formValid = await this.$refs.PreferredLocationFormRef.validate();

      if (formValid.valid) {
        this.btnLoading = true;
        let data = {
          title: this.title,
          type: this.type_selected,
          date_sched: this.date_sched,
          time_from: this.time_from,
          time_to: this.time_to,
          venue: this.venue,
        };

        this.axiosCall(
          "/attendance/student-prac-attendances-update/" + this.data.id,
          "PATCH",
          data,
        ).then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    closeD() {
      eventBus.emit("closeStudentPracticumAttendanceDialog", true);
      this.btnLoading = false;
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap");

.form-card {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  border-radius: 14px !important;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: #16a34a;
  color: #fff;
  padding: 18px 20px;
}
.dialog-header-title {
  font-size: 16px;
  font-weight: 700;
}
.dialog-header-sub {
  font-size: 12px;
  opacity: 0.9;
  margin-top: 2px;
}

.form-body {
  padding: 20px !important;
  max-height: 65vh;
}

.field-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 6px;
}

.type-preview {
  display: inline-flex;
  margin-top: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 20px;
}

.dialog-actions {
  padding: 14px 20px !important;
}

.cancel-btn {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  background: #f3f4f6 !important;
  color: #374151 !important;
  border: 1px solid #e5e7eb !important;
  text-transform: none !important;
  height: 36px !important;
  padding: 0 16px !important;
}

.save-btn {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  background: #16a34a !important;
  color: #fff !important;
  text-transform: none !important;
  height: 36px !important;
  padding: 0 16px !important;
}
</style>
